import { CheckLinear } from "../Iconsax/CheckLinear.js";
import { CloseLinear } from "../Iconsax/CloseLinear.js";
import type { IconsaxComponent } from "../Iconsax/Iconsax.types.js";
import { InputFeedbackProps } from "./InputFeedback.types.js";

export const INPUT_FEEDBACK_ICON_MAP: Record<InputFeedbackProps["type"], IconsaxComponent> = {
    success: CheckLinear,
    error: CloseLinear,
};
